// extracted by mini-css-extract-plugin
module.exports = {"success_toastr_header":"styles_success_toastr_header__1jID-","error_toastr_header":"styles_error_toastr_header__y3SRi","toastBody":"styles_toastBody__2FZEH"};